import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiperGallery = () => {
  new Swiper('.swiper-gallery', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 20,
    speed: 600,
    grabCursor: true,
    breakpoints: {
      320: {
        slidesPerView: 1.05,
        spaceBetween: 0,
      },
      1440: {
        slidesPerView: 3.1,
        spaceBetween: 10,
      },
    },
  });
};

export default swiperGallery;
